
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';

export default function CareersPage() {
  const [selectedDepartment, setSelectedDepartment] = useState('all');

  const jobOpenings = [
    {
      id: 1,
      title: 'Senior Software Engineer',
      department: 'Engineering',
      location: 'Nagpur',
      type: 'Full-time',
      experience: '3-5 years',
      description: 'Build scalable mobile and web applications for our growing platform. Work with React, Node.js, and mobile technologies.',
      requirements: ['3+ years React/Node.js experience', 'Mobile app development experience', 'Strong problem-solving skills']
    },
    {
      id: 2,
      title: 'Product Manager',
      department: 'Product',
      location: 'Nagpur',
      type: 'Full-time',
      experience: '2-4 years',
      description: 'Drive product strategy and roadmap for our customer and partner apps. Work closely with engineering and design teams.',
      requirements: ['Product management experience', 'Data-driven decision making', 'Customer-focused mindset']
    },
    {
      id: 3,
      title: 'Marketing Manager',
      department: 'Marketing',
      location: 'Nagpur',
      type: 'Full-time',
      experience: '2-3 years',
      description: 'Lead digital marketing campaigns and brand awareness initiatives. Focus on customer acquisition and retention.',
      requirements: ['Digital marketing experience', 'Content creation skills', 'Analytics and performance tracking']
    },
    {
      id: 4,
      title: 'Operations Coordinator',
      department: 'Operations',
      location: 'Nagpur',
      type: 'Full-time',
      experience: '1-2 years',
      description: 'Coordinate with service partners and ensure smooth operations. Handle customer escalations and quality control.',
      requirements: ['Operations experience', 'Strong communication skills', 'Problem-solving abilities']
    },
    {
      id: 5,
      title: 'HR Business Partner',
      department: 'HR',
      location: 'Nagpur',
      type: 'Full-time',
      experience: '3-5 years',
      description: 'Partner with leadership to build our team culture and implement HR strategies. Focus on talent acquisition and retention.',
      requirements: ['HR experience', 'Talent acquisition expertise', 'Strong interpersonal skills']
    },
    {
      id: 6,
      title: 'Customer Support Executive',
      department: 'Support',
      location: 'Nagpur',
      type: 'Full-time',
      experience: '0-2 years',
      description: 'Provide excellent customer support via phone, chat, and email. Help customers with bookings and resolve issues.',
      requirements: ['Excellent communication skills', 'Customer service mindset', 'Multi-tasking abilities']
    }
  ];

  const departments = ['all', 'Engineering', 'Product', 'Marketing', 'Operations', 'HR', 'Support'];

  const filteredJobs = selectedDepartment === 'all' 
    ? jobOpenings 
    : jobOpenings.filter(job => job.department === selectedDepartment);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-white">
      <Navbar />

      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-r from-purple-600 to-purple-700 text-white relative overflow-hidden"
               style={{
                 backgroundImage: `url('https://readdy.ai/api/search-image?query=modern%20office%20environment%20with%20diverse%20team%20working%20together%2C%20startup%20company%20culture%2C%20purple%20and%20white%20corporate%20theme%2C%20collaborative%20workspace%2C%20professional%20career%20opportunities%2C%20success%20and%20growth%20concept&width=1200&height=600&seq=careers-hero&orientation=landscape')`,
                 backgroundSize: 'cover',
                 backgroundPosition: 'center'
               }}>
        <div className="absolute inset-0 bg-purple-600/80"></div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold mb-6">
              Join the BNM Team
            </h1>
            <p className="text-xl mb-8">
              Help us revolutionize home services and build the future of on-demand economy
            </p>
            <div className="flex flex-wrap gap-4">
              <div className="flex items-center bg-white/20 px-4 py-2 rounded-full">
                <i className="ri-map-pin-line mr-2"></i>
                <span>Nagpur, India</span>
              </div>
              <div className="flex items-center bg-white/20 px-4 py-2 rounded-full">
                <i className="ri-team-line mr-2"></i>
                <span>50+ Team Members</span>
              </div>
              <div className="flex items-center bg-white/20 px-4 py-2 rounded-full">
                <i className="ri-rocket-line mr-2"></i>
                <span>High Growth Startup</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Join BNM */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Why Work at BNM?</h2>
            <p className="text-xl text-gray-600">Be part of something bigger</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-lightbulb-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Innovation First</h3>
              <p className="text-gray-600">
                Work with cutting-edge technology and contribute to innovative solutions that impact millions of lives
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-line-chart-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Rapid Growth</h3>
              <p className="text-gray-600">
                Join a fast-growing startup where your contributions directly impact company success and your career growth
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-heart-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Great Culture</h3>
              <p className="text-gray-600">
                Work in an inclusive, collaborative environment that values diversity, creativity, and work-life balance
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Job Openings */}
      <section className="py-16 bg-purple-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Open Positions</h2>
            <p className="text-xl text-gray-600">Find your perfect role</p>
          </div>

          {/* Department Filter */}
          <div className="flex flex-wrap justify-center gap-3 mb-12">
            {departments.map((dept) => (
              <button
                key={dept}
                onClick={() => setSelectedDepartment(dept)}
                className={`px-6 py-2 rounded-full font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  selectedDepartment === dept
                    ? 'bg-purple-600 text-white'
                    : 'bg-white text-gray-700 hover:bg-purple-100'
                }`}
              >
                {dept === 'all' ? 'All Departments' : dept}
              </button>
            ))}
          </div>

          {/* Job Listings */}
          <div className="max-w-4xl mx-auto space-y-6">
            {filteredJobs.map((job) => (
              <div key={job.id} className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 hover:shadow-md transition-shadow">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
                  <div>
                    <h3 className="text-xl font-semibold text-gray-800 mb-2">{job.title}</h3>
                    <div className="flex flex-wrap gap-4 text-sm text-gray-600">
                      <span className="flex items-center">
                        <i className="ri-building-line mr-1"></i>
                        {job.department}
                      </span>
                      <span className="flex items-center">
                        <i className="ri-map-pin-line mr-1"></i>
                        {job.location}
                      </span>
                      <span className="flex items-center">
                        <i className="ri-time-line mr-1"></i>
                        {job.type}
                      </span>
                      <span className="flex items-center">
                        <i className="ri-user-line mr-1"></i>
                        {job.experience}
                      </span>
                    </div>
                  </div>
                  <Link
                    to="/apply"
                    className="bg-purple-600 text-white px-6 py-2 rounded-full font-semibold hover:bg-purple-700 transition-colors cursor-pointer whitespace-nowrap mt-4 md:mt-0 flex items-center justify-center"
                  >
                    Apply Now
                  </Link>
                </div>
                
                <p className="text-gray-600 mb-4">{job.description}</p>
                
                <div>
                  <h4 className="text-sm font-semibold text-gray-800 mb-2">Requirements:</h4>
                  <ul className="text-sm text-gray-600 space-y-1">
                    {job.requirements.map((req, index) => (
                      <li key={index} className="flex items-start">
                        <i className="ri-check-line text-green-600 mr-2 mt-0.5 flex-shrink-0"></i>
                        {req}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>

          {filteredJobs.length === 0 && (
            <div className="text-center py-12">
              <i className="ri-search-line text-4xl text-gray-300 mb-4"></i>
              <h3 className="text-xl font-semibold text-gray-600 mb-2">No openings found</h3>
              <p className="text-gray-500">Try selecting a different department or check back later</p>
            </div>
          )}
        </div>
      </section>

      {/* Benefits */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Employee Benefits</h2>
            <p className="text-xl text-gray-600">We take care of our team</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-money-rupee-circle-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Competitive Salary</h3>
              <p className="text-gray-600 text-sm">Market-leading compensation packages</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-health-book-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Health Insurance</h3>
              <p className="text-gray-600 text-sm">Comprehensive medical coverage</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-book-open-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Learning Budget</h3>
              <p className="text-gray-600 text-sm">Annual budget for courses and conferences</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-calendar-line text-2xl text-red-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Flexible PTO</h3>
              <p className="text-gray-600 text-sm">Generous vacation and sick leave policy</p>
            </div>
          </div>
        </div>
      </section>

      {/* Application Process */}
      <section className="py-16 bg-purple-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Application Process</h2>
            <p className="text-xl text-gray-600">Simple and transparent hiring process</p>
          </div>

          <div className="grid md:grid-cols-4 gap-8 max-w-5xl mx-auto">
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-600 text-white rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-xl font-bold">1</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Apply Online</h3>
              <p className="text-gray-600 text-sm">Submit your application through our careers page</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-purple-600 text-white rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-xl font-bold">2</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Initial Screening</h3>
              <p className="text-gray-600 text-sm">HR team reviews your profile and experience</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-purple-600 text-white rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-xl font-bold">3</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Technical Round</h3>
              <p className="text-gray-600 text-sm">Role-specific interviews and skill assessment</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-purple-600 text-white rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-xl font-bold">4</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Final Interview</h3>
              <p className="text-gray-600 text-sm">Meet the team and discuss role expectations</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact HR */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">Have Questions?</h2>
          <p className="text-xl text-gray-600 mb-8">
            Our HR team is here to help with your career questions
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="mailto:careers@baainearme.com" className="flex items-center bg-purple-600 text-white px-8 py-4 rounded-full font-semibold hover:bg-purple-700 transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-mail-line mr-2"></i>
              careers@baainearme.com
            </a>
            <a href="tel:93074 19845" className="flex items-center bg-gray-100 text-gray-800 px-8 py-4 rounded-full font-semibold hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-phone-line mr-2"></i>
              Call: 93074 19845
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              {/* BNM logo (SVG) — scalable, color via currentColor */}
<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 420 160"
  className="h-10 text-white"   // change to text-purple-600 etc.
  role="img"
  aria-label="BNM · Baainearme"
>
  <g fill="none" stroke="currentColor" strokeWidth="12" strokeLinecap="round">
    {/* Left ring */}
    <circle cx="50" cy="60" r="40" />
    {/* Vertical divider */}
    <line x1="110" y1="20" x2="110" y2="120" />
  </g>

  {/* Text block */}
  <g fill="currentColor">
    {/* BNM */}
    <text
      x="140"
      y="72"
      fontFamily="Poppins, Inter, Arial, sans-serif"
      fontWeight="800"
      fontSize="56"
    >
      BNM
    </text>

    {/* Baainearme */}
    <text
      x="140"
      y="120"
      fontFamily="Poppins, Inter, Arial, sans-serif"
      fontWeight="700"
      fontSize="32"
    >
      Baainearme
    </text>
  </g>
</svg>

              <p className="text-gray-400">
                Join our mission to revolutionize home services
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">For Job Seekers</h3>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#" className="hover:text-white cursor-pointer">View All Jobs</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer">Employee Benefits</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer">Company Culture</a></li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Company</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/about" className="hover:text-white cursor-pointer">About Us</Link></li>
                <li><Link to="/customer" className="hover:text-white cursor-pointer">For Customers</Link></li>
                <li><Link to="/partner" className="hover:text-white cursor-pointer">For Partners</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Contact</h3>
              <ul className="space-y-2 text-gray-400">
                <li>📧 careers@baainearme.com</li>
                <li>📞 93074 19845</li>
                <li>📍 Nagpur, Maharashtra</li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 Baainearme. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
